<template>
  <lm-modal
    :ref="modalName"
    :name="modalName"
    :type="modalType"
    class="ModalTopicsSearcher"
    title="Topic Selector"
    full-height
    :dismissible="false"
  >
    <template slot="error">
      <lm-alert
        v-show="error"
        msg="Select at least one related topic"
        @close="error = false"
      />
    </template>
    <topics-searcher />
    <template slot="footer">
      <lm-modal-button title="Done" type="primary" @click="closeModal" />
    </template>
  </lm-modal>
</template>

<script>
import LmModalButton from '@/components/ui/button/LmModalButton'
import LmAlert from '@/components/ui/LmAlert'
import {Modal, ModalType} from '@/lib/definitions'
import LmModal from '@/components/ui/LmModal'
import TopicsSearcher from '@/components/landscape/common/TopicsSearcher'
import {mapGetters} from 'vuex'

export default {
  name: 'ModalTopicsSearcher',
  components: {
    LmAlert,
    LmModalButton,
    LmModal,
    TopicsSearcher
  },
  data() {
    return {
      modalName: Modal.TOPIC_SEARCHER,
      modalType: ModalType.SUBMODAL,
      error: false
    }
  },
  computed: {
    ...mapGetters({
      insightsTopics: 'insights/helpers/tempTopics'
    }),
    totalTopics() {
      return this.insightsTopics.length
    }
  },
  watch: {
    totalTopics(newValue, oldValue) {
      if (oldValue === 0 && newValue > oldValue) this.error = false
    }
  },
  methods: {
    closeModal() {
      if (this.$route.query.required && this.totalTopics === 0) {
        this.error = true
        return
      }
      this.$router.removeKeyFromQuery('required')
      this.$refs[this.modalName].close(true)
    }
  }
}
</script>
